export function daysDeclensionFunc(n: number): string {
  if (n % 10 === 1 && n % 100 !== 11) {
    return `${n} день`;
  }
  if (n % 10 >= 2 && n % 10 <= 4 && !(n % 100 >= 12 && n % 100 <= 14)) {
    return `${n} дня`;
  }
  return `${n} дней`;
}
